// Import TinyMCE
import tinymce from 'tinymce';

import 'tinymce/models/dom';

import '@tinymce/tinymce-jquery';

// Default icons are required for TinyMCE 5.3 or above
import 'tinymce/icons/default';

// A theme is also required
import 'tinymce/themes/silver';

// Any plugins you want to use has to be imported
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/lists';

  tinymce.init({
    skin: false,
    content_css: false,
    selector: '.tiny',
    plugins: ['advlist', 'lists'],
    height: 300,
    menubar: false,    
    toolbar: 'undo redo | formatselect | ' +
    'bold italic forecolor backcolor | alignleft aligncenter ' +
    'alignright alignjustify | bullist numlist outdent indent | ' +
    'removeformat'    
  });